export default {
  logs: [],
  errors: null
};
